import React, { useCallback } from 'react';
import Link from '../../../../../elements/Link';
import RoundImage from '../../../../../elements/RoundImage';
import StartNetworkingIcon from '../../../../StartNetworking/StartNetworkingIcon/StartNetworkingIcon';

/**
 * Renders a placeholder for home event participants with avatar images.
 *
 * @param {Object} props - The properties object containing className, avatarClassName, participantsLink, and size.
 * @param {string} props.className - The class name to apply to the container element.
 * @param {string} props.avatarClassName - The class name to apply to the avatar element.
 * @param {string} props.participantsLink - The link to the participants page.
 * @param {number} props.size - The number of placeholder elements to render.
 * @return {Array} An array of placeholder elements for home event participants.
 */
function HomeEventParticipantsPlaceholder(props) {
    const {className = '', avatarClassName = '', participantsLink = '', size = 5} = props;

    const handleIconClick = useCallback(e => e.stopPropagation(), []);

    return (
        <>
            {new Array(size).fill(null).map((j, i) => (
                <Link className={className} href={participantsLink} key={i}>
                    <RoundImage className={['avatar', avatarClassName].join(' ')} src="/img/pixel.png" size={50} />
                </Link>
            ))}
            <StartNetworkingIcon onClick={handleIconClick} />
        </>
    );
}

export default HomeEventParticipantsPlaceholder;
